import React from 'react'
import CSS from './LandingPage.module.css';

function Section1() {
    return (
        <div className={`${CSS.section1}`}>
            <div className={CSS.image}></div>
            <div className={CSS.content1}>
            <h1 className="mt-5">About CO-Centric </h1>
            <p className="lead text-secondary">We are an online and offline two sided marketplace for manufacturing industries with a motto of driving  business with network.</p>
            </div>
        </div>
    )
}

export default Section1
